export default class ColorService {
	private colors: string[] = ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0'];
	private lastReturnedColorIndex = -1;

	getNewColor() {
		this.lastReturnedColorIndex++;
		if (this.lastReturnedColorIndex >= this.colors.length)
			this.lastReturnedColorIndex = 0;
		return this.colors[this.lastReturnedColorIndex];
	}

	reset() {
		this.lastReturnedColorIndex = -1;
	}
}
